import { Currency } from '@/Domain/Batch/Currency'
import { Percentage } from '@/Domain/Expediente/Percentage'
import { Award } from '@/Domain/Expediente'
import { NewDate } from '@/Domain/News'

export class AwardDto {
    private _nomeAdxudicatario: string
    private _importeOferta: Currency
    private _fraccionaPago: boolean
    private _iva: Percentage
    private _importeIva: Currency
    private _importeTotal: Currency

    private _dataNotificacion: NewDate | null
    private _prazoDocumentacion: NewDate | null
    private _gastosAnuncio: Currency | null

    private _garantiaDefinitivaPorcentaje: Percentage | null
    private _garantiaDefinitivaImporte: Currency | null
    private _garantiaComplementariaPorcentaje: Percentage | null
    private _garantiaComplementariaImporte: Currency | null
    private _garantiaTotalPorcentaje: Percentage | null
    private _garantiaTotalImporte: Currency | null

    private _dataIngresoMadeira: NewDate | null
    private _dataIngresoAnuncio: NewDate | null
    private _dataIngresoTaxas: NewDate | null
    private _dataGarantiaTotal: NewDate | null
    private _dataPagoIvaComunidade: NewDate | null
    private _dataDevolucionGarantia: NewDate | null
    private _dataNotificacionPertenza: NewDate | null
    private _dataAdxudicacion: NewDate | null

    static fromAward (award: Award): AwardDto {
      return new AwardDto(
        award.nomeAdxudicatario,
        award.importeOferta,
        award.fraccionaPago,
        new Percentage(award.iva),

        award.dataNotificacion ? new NewDate(award.dataNotificacion) : null,
        award.prazoDocumentacion ? new NewDate(award.prazoDocumentacion) : null,
        award.gastosAnuncio,

        new Percentage(award.garantiaDefinitivaPorcentaje),
        award.garantiaDefinitivaImporte,
        new Percentage(award.garantiaComplementariaPorcentaje),
        award.garantiaComplementariaImporte,
        new Percentage(award.garantiaTotalPorcentaje),
        award.garantiaTotalImporte,

        award.dataIngresoMadeira ? new NewDate(award.dataIngresoMadeira) : null,
        award.dataIngresoAnuncio ? new NewDate(award.dataIngresoAnuncio) : null,
        award.dataIngresoTaxas ? new NewDate(award.dataIngresoTaxas) : null,
        award.dataGarantiaTotal ? new NewDate(award.dataGarantiaTotal) : null,
        award.dataPagoIvaComunidade ? new NewDate(award.dataPagoIvaComunidade) : null,
        award.dataDevolucionGarantia ? new NewDate(award.dataDevolucionGarantia) : null,
        award.dataNotificacionPertenza ? new NewDate(award.dataNotificacionPertenza) : null,
        award.dataAdxudicacion ? new NewDate(award.dataAdxudicacion) : null
      )
    }

    constructor (
      nomeAdxudicatario: string,
      importeOferta: Currency,
      fraccionaPago: boolean,
      iva: Percentage,

      dataNotificacion: NewDate | null,
      prazoDocumentacion: NewDate | null,
      gastosAnuncio: Currency | null,

      garantiaDefinitivaPorcentaje: Percentage | null,
      garantiaDefinitivaImporte: Currency | null,
      garantiaComplementariaPorcentaje: Percentage | null,
      garantiaComplementariaImporte: Currency | null,
      garantiaTotalPorcentaje: Percentage | null,
      garantiaTotalImporte: Currency | null,

      dataIngresoMadeira: NewDate | null,
      dataIngresoAnuncio: NewDate | null,
      dataIngresoTaxas: NewDate | null,
      dataGarantiaTotal: NewDate | null,
      dataPagoIvaComunidade: NewDate | null,
      dataDevolucionGarantia: NewDate | null,
      dataNotificacionPertenza: NewDate | null,
      dataAdxudicacion: NewDate | null
    ) {
      this._nomeAdxudicatario = nomeAdxudicatario
      this._importeOferta = importeOferta
      this._fraccionaPago = fraccionaPago
      this._iva = iva

      this._importeIva = this.calculoImporteIva(importeOferta, iva)
      this._importeTotal = this.calculoImporteTotal(importeOferta, this._importeIva)

      this._dataNotificacion = dataNotificacion
      this._prazoDocumentacion = prazoDocumentacion
      this._gastosAnuncio = gastosAnuncio

      this._garantiaDefinitivaPorcentaje = garantiaDefinitivaPorcentaje
      this._garantiaDefinitivaImporte = garantiaDefinitivaImporte
      this._garantiaComplementariaPorcentaje = garantiaComplementariaPorcentaje
      this._garantiaComplementariaImporte = garantiaComplementariaImporte
      this._garantiaTotalPorcentaje = garantiaTotalPorcentaje
      this._garantiaTotalImporte = garantiaTotalImporte

      this._dataIngresoMadeira = dataIngresoMadeira
      this._dataIngresoAnuncio = dataIngresoAnuncio
      this._dataIngresoTaxas = dataIngresoTaxas
      this._dataGarantiaTotal = dataGarantiaTotal
      this._dataPagoIvaComunidade = dataPagoIvaComunidade
      this._dataDevolucionGarantia = dataDevolucionGarantia
      this._dataNotificacionPertenza = dataNotificacionPertenza
      this._dataAdxudicacion = dataAdxudicacion
    }

    get nomeAdxudicatario (): string {
      return this._nomeAdxudicatario
    }

    get importeOferta (): Currency {
      return this._importeOferta
    }

    get fraccionaPago (): boolean {
      return this._fraccionaPago
    }

    get iva (): number {
      return this._iva.percentage()
    }

    get importeIva (): Currency {
      return this._importeIva
    }

    get importeTotal (): Currency {
      return this._importeTotal
    }

    get dataNotificacion (): string {
      return this._dataNotificacion === null ? '' : this._dataNotificacion.date()
    }

    get prazoDocumentacion (): string {
      if (this._prazoDocumentacion !== null) {
        return this._prazoDocumentacion.date()
      } else { return '' }
    }

    get gastosAnuncio (): Currency {
      if (this._gastosAnuncio !== null) {
        return this._gastosAnuncio
      } else { return new Currency(0) }
    }

    get garantiaDefinitivaPorcentaje (): number {
      if (this._garantiaDefinitivaPorcentaje !== null) {
        return this._garantiaDefinitivaPorcentaje.percentage()
      } else { return 0 }
    }

    get garantiaDefinitivaImporte (): Currency {
      if (this._garantiaDefinitivaImporte !== null) {
        return this._garantiaDefinitivaImporte
      } else { return new Currency(0) }
    }

    get garantiaComplementariaPorcentaje (): number {
      if (this._garantiaComplementariaPorcentaje !== null) {
        return this._garantiaComplementariaPorcentaje.percentage()
      } else { return 0 }
    }

    get garantiaComplementariaImporte (): Currency {
      if (this._garantiaComplementariaImporte !== null) {
        return this._garantiaComplementariaImporte
      } else { return new Currency(0) }
    }

    get garantiaTotalPorcentaje (): number {
      if (this._garantiaTotalPorcentaje !== null) {
        return this._garantiaTotalPorcentaje.percentage()
      } else { return 0 }
    }

    get garantiaTotalImporte (): Currency {
      if (this._garantiaTotalImporte !== null) {
        return this._garantiaTotalImporte
      } else { return new Currency(0) }
    }

    get dataIngresoMadeira (): string {
      if (this._dataIngresoMadeira !== null) {
        return this._dataIngresoMadeira.date()
      } else { return '' }
    }

    get dataIngresoAnuncio (): string {
      if (this._dataIngresoAnuncio !== null) {
        return this._dataIngresoAnuncio.date()
      } else { return '' }
    }

    get dataIngresoTaxas (): string {
      if (this._dataIngresoTaxas !== null) {
        return this._dataIngresoTaxas.date()
      } else { return '' }
    }

    get dataGarantiaTotal (): string {
      if (this._dataGarantiaTotal !== null) {
        return this._dataGarantiaTotal.date()
      } else { return '' }
    }

    get dataPagoIvaComunidade (): string {
      if (this._dataPagoIvaComunidade !== null) {
        return this._dataPagoIvaComunidade.date()
      } else { return '' }
    }

    get dataDevolucionGarantia (): string {
      if (this._dataDevolucionGarantia !== null) {
        return this._dataDevolucionGarantia.date()
      } else { return '' }
    }

    get dataNotificacionPertenza (): string {
      if (this._dataNotificacionPertenza !== null) {
        return this._dataNotificacionPertenza.date()
      } else { return '' }
    }

    get dataAdxudicacion (): string {
      if (this._dataAdxudicacion !== null) {
        return this._dataAdxudicacion.date()
      } else { return '' }
    }

    private calculoImporteIva (importe: Currency, iva: Percentage): Currency {
      return new Currency((iva.multiply(importe.value())) / 100)
    }

    private calculoImporteTotal (importe: Currency, importeIva: Currency): Currency {
      return new Currency(importe.add(importeIva).value())
    }
}
